import webp from './webp'
import backFn from './backFn'
import statusBar from './statusBar'
import statusBarHeight from './statusBarHeight'
import observer from './observer'
import autoAnimate from './auto-animate'

export default {
  webp,
  backFn,
  statusBar,
  statusBarHeight,
  observer,
  autoAnimate
}
